<template>
  <div id="app">
    <router-view />
    <Loader />
    <Toastr />
  </div>
</template>

<script>
import Toastr from './components/Toastr';
import { Loader } from './components/common';

export default {
  components: { Loader, Toastr },
};
</script>
